/*# sourceMappingURL=mailbox-list.component-4I2W3DE2.css.map */
